/**
 * Critical error categories tracked in Live Monitoring.
 * Only errors in these areas are sent to the monitoring API.
 */

import { isNetworkError } from '../utils/apiErrors';

export const CRITICAL_CATEGORIES = ['support', 'cctv', 'reload', 'login', 'other'];

const UNKNOWN_ERROR_PATTERN = /^unknown(\s+error)?$/i;

const ENDPOINT_RULES = [
    {
        category: 'login',
        patterns: [
            /\/parentapp\/childLoginOTP\b/i,
            /\/parentapp\/childLoginViaOTPDetails\b/i,
        ],
    },
    {
        category: 'reload',
        patterns: [/\/parentapp\/childLoginReloadDetails\b/i],
    },
    {
        category: 'cctv',
        patterns: [
            /\/userauth\/generateEmbedHash\b/i,
            /\/userauth\/getCctvAppToken\b/i,
            /\/app-auth\b/i,
            /Uptimerobot_listCentresStatus/i,
            /cctvConnectionCheck/i,
        ],
    },
    {
        category: 'support',
        patterns: [
            /\/parentapp\/request\b/i,
            /\/parentapp\/createTicket\b/i,
            /\/parentapp\/sendFeeCertificate\b/i,
            /\/financials\//i,
            /\/chargebees\//i,
            /\/franchises\/resumeChild\b/i,
            /\/franchises\/pauseChild/i,
            /\/userauth\/resetDoorPin\b/i,
        ],
    },
];

/** Map a request URL/path to a critical category, or null if not tracked. */
export function classifyErrorCategory(endpoint) {
    if (!endpoint) return null;
    const path = String(endpoint).split('?')[0];
    for (const { category, patterns } of ENDPOINT_RULES) {
        if (patterns.some((pattern) => pattern.test(path))) {
            return category;
        }
    }
    return null;
}

export function isCriticalCategory(category) {
    return CRITICAL_CATEGORIES.includes(category);
}

/** Network failures and generic unknown-error messages → other. */
export function classifyOtherError(message, error) {
    if (isNetworkError(error) || isNetworkError(message)) return 'other';
    if (typeof message === 'string' && UNKNOWN_ERROR_PATTERN.test(message.trim())) {
        return 'other';
    }
    return null;
}
